















































































































































































































































































































import {Component, Prop, Mixins} from "vue-property-decorator";
import ObjectEditLayout from "@service/layouts/ObjectEditLayout.vue";
import ControlWrapperBorderless from "@share/common/ControlWrapperBorderless.vue";
import BorderlessTexarea from "@share/common/form/form-controls/text/BorderlessTextarea.vue";
import FormGroup from "@share/common/form/form-group/FormGroup.vue";
import BackButton from "@service/components/common/back-button/BackButton.vue";
import TextSelect from "@share/common/form/form-controls/select/variations/text-select/TextSelect.vue";
import SingleSelect from "@share/common/form/form-controls/select/variations/single-select/SingleSelect.vue";
import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";
import E404 from "@service/views/errors/e404.vue";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import {SelectObjectSourceService} from "@share/common/services/selectControl/SelectObjectSourceService"
import {UserProfile} from "@api/models/UserProfile";
import {Debounce} from "vue-debounce-decorator";
import ToggleButton from "@common/vue-toggle-btn/toggle-btn.vue";
import DatePickerInput from '@share/common/form/form-controls/date/date-picker/DatePickerInput.vue';
import DragNDrop, { FilesPayload } from "@share/common/form/form-controls/file/DragNDrop.vue"
import {noticeActions} from "@service/store/notice/actions";
import {Notice} from "@service/components/toast/type/Notice";
import {NoticeLevel} from "@service/components/toast/type/Enums";
import i18n from "@service/locale/i18";
import CommentsView from "@share/comments/components/Comments.vue";
import ObjectLayout from "@service/layouts/ObjectViewLayout.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";
import {TicketSchema} from "@share/ticketSystem/enums/TicketSchemas";
import TicketFormBase from "@share/ticketSystem/components/TicketFormBase";
import { EventBus } from '@common/EventBus';
import Speaker from '@share/session/components/Speaker.vue';
import BorderlessText from "@share/common/form/form-controls/text/BorderlessText.vue";
import BorderlessCurrnecy from "@share/common/form/form-controls/text/BorderlessCurrency.vue";

const validations = {
    ticket: {
        responsibleUserId: {
            required
        },
        status: {
            required
        }
    }
}

@Component({
    components: {
        AdminPanel,
        BackButton,
        BorderlessTexarea,
        BorderlessText,
        BorderlessCurrnecy,
        ControlWrapperBorderless,
        E404,
        FormGroup,
        ObjectEditLayout,
        SingleSelect,
        TextSelect,
        ToggleButton,
        DatePickerInput,
        DragNDrop,
        CommentsView,
        ObjectLayout,
        BounceSpinner,
        Speaker
    },
    validations
})

export default class TicketEdit extends Mixins(validationMixin, TicketFormBase) {
    @Prop({required: true}) id: string;

    async mounted() {
        this.selectSourceService = new SelectObjectSourceService(this.objectRepository);

        try {
            //TODO: merge with create form
            const [categories, statuses] = await Promise.all([
                this.ticketService.getCategories(this.ticketType),
                this.ticketService.getStatuses(this.ticketType)
            ]);
            this.searchedSources.categories = categories?.map((item) => ({ id: item.id, title: item.title })) || [];
            //@todo check typing
            this.searchedSources.statuses = (statuses?.map((item) => ({ id: item.id, title: item.title })) || []) as any;

            if (this.ticketId) {
                this.ticket = await this.ticketService.getTicketById(this.ticketType, this.ticketId);

                if (this.ticket) {

                    const fileIds = this.getFilesIds();

                    const [files, users] = await Promise.all([
                        fileIds.length ? this.getFilesByIds(fileIds) : [],
                        this.ticketService.getTicketsUsers([this.ticket])
                    ]);

                    this.setLoadedFiles(files);

                    this.users = users;
                    this.ticketOriginal = Object.assign({}, this.ticket);
                    await this.setSelectedData();
                }

            } else {
                this.show404();
            }
        }
       catch(e) {
            this.$store.dispatch('reportException', e, {root: true});
        }
        finally {
            this.isLoading = false;
        }

    }

    setLoadedFiles(files: FilesPayload) {
        this.fileIdsValue = files.filter((item) => this.ticket?.fileIds?.includes(item.file.id || ""))
        this.imageFileIdsValue = files.filter((item) => this.ticket?.imageFileIds?.includes(item.file.id || ""))
    }

    getFilesIds() {
        let ids: string[] = [];

        const filesIds = this.ticket?.imageFileIds;
        const imageFilesIds = this.ticket?.fileIds;

        if(filesIds?.length) {
            ids = ids.concat(filesIds)
        }

        if(imageFilesIds?.length) {
            ids = ids.concat(imageFilesIds)
        }

        return ids;
    }

    async setSelectedData() {
        if(this.ticketId) {
            this.refTicketData = await this.ticketService.getTicketById(
                this.ticketType,
                this.ticketId,
                {
                    include: [
                        {'company': ['id', 'title']},
                        {'direction': ['id', 'title']},
                        {'branch': ['id', 'title']},
                        {'status': ['id', 'title']},
                        {'category': ['id', 'title']}
                    ]
                }
            );
        }

        if (this.refTicketData) {
            this.selectedListSources.companies.push(this.refTicketData.company);
            this.selectedListSources.statuses.push(this.refTicketData.status);
            this.selectedListSources.categories.push(this.refTicketData.category);
            this.selectedListSources.branches.push(this.refTicketData.branch);
            this.selectedListSources.directions.push(this.refTicketData.direction);
        }

        if (this.users) {
            let user: UserProfile | undefined = undefined;

            if (this.ticket?.responsibleUserId) {
                user = this.users.find(item => item.userId === this.ticket?.responsibleUserId);
                if (user) {
                    this.selectedListSources.responsibleUser.push({
                        id: this.ticket.responsibleUserId.toString(),
                        title: this.getUserTitleForSelect(user)
                    });
                }
            }

            if (this.ticket?.responsibleForImplementationUserId) {
                user = this.users.find(item => item.userId === this.ticket?.responsibleForImplementationUserId);
                if (user) {
                    this.selectedListSources.responsibleForImplementationUser.push({
                        id: this.ticket.responsibleForImplementationUserId.toString(),
                        title: this.getUserTitleForSelect(user)
                    });
                }
            }
        }
    }

    @Debounce(500)
    async save() {
        this.$v.$touch();
        if (this.vTicket && !this.vTicket.$invalid && this.ticketId) {
            try {
                let ticket = Object.assign({}, this.ticket);
                ['id', 'updatedAt', 'createdAt', 'updatedBy', 'ownerIds', 'ownerId'].forEach(field => delete ticket[field]);
                await this.ticketService.updateTicket(this.ticketType, this.ticketId, ticket);
                const notice: Notice = {
                    text: i18n.t("tickets.ticketSuccessfullyUpdated").toString(),
                    level: NoticeLevel.success
                }
                this.$store.dispatch(noticeActions.submitNotice, notice);

                if(!this.selfAdminPanelHandling) {
                    this.$emit('save')
                }
            } catch (e) {
                this.$store.dispatch('reportException', e, {root: true});
                const notice: Notice = {
                    text: this.$t("tickets.ticketEditError").toString(),
                    level: NoticeLevel.danger
                }

                this.$store.dispatch(noticeActions.submitNotice, notice);
            }
        }
    }

    get schemaId() {
        return this.ticketType === TicketType.idea ? TicketSchema.idea : TicketSchema.problem;
    }

    get ticketId(): string | null {
        return this.id || this.$route.params.id
    }

    get ownerId() {
        return this.ticket?.ownerIds?.[0];
    }

    get owner() {
        return this.users.find((user: UserProfile) => user.userId === this.ownerId);
    }

    select(user: UserProfile) {
        if (this.$store.getters['userId'] !== user.userId) {
            EventBus.$emit("showChatByUserId", user.userId);
        }
    }
}
